import { createSelector } from 'reselect'
import filter from 'lodash/filter'
import at from 'lodash/at'
import get from 'lodash/get'
import countBy from 'lodash/countBy'
import map from 'lodash/map'

export const workSummariesSelector = state => (
  at(state.workSummaries, state.pagination.workSummaries.ids || [])
)

export const inProgressSelector = statusSelectorFactory('in_progress')
export const pendingApprovalSelector = statusSelectorFactory('pending_approval')
export const archiveSelector = statusSelectorFactory('signed_off')

function statusSelectorFactory (status) {
  return createSelector(
    workSummariesSelector,
    workSummaries => filter(workSummaries, { status, summaryType: 'WorkOrder' })
  )
}

const getWorkOrderAreaSummaries = (state, props) => get(state.workOrders, `${props.workOrderId}.workAreaSummaries`, [])
const getWorkAreaSummaries = (state, props) => state.workAreaSummaries

export const countByAreaTypesSelector = createSelector(
  [getWorkOrderAreaSummaries, getWorkAreaSummaries],
  (workOrderAreaSummaries, workAreaSummaries) => at(workAreaSummaries, workOrderAreaSummaries || []).reduce((obj, curr) => {
    obj[curr.areaTypeName] = curr.areasServicedQuantity
    return obj
  }, {})
)


// WEBPACK FOOTER //
// ./src/selectors/work-summary-selectors.js